export function toCurrency(valor) {
  return parseFloat(valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
}

export function toCurrencyTransform(valor) {
  let valorSemCifrao = valor.replace(/^R\$\s?/, '');
  let newVal = parseFloat(valorSemCifrao.replace(/\./g, '').replace(',', '.'))
  let formatted = toCurrency(newVal);
  return formatted
}

export function toCurrencySave(valor) {
  // Se for null ou undefined, retorna 0
  if (valor === null || valor === undefined) {
    return 0;
  }
  // Se já for número, retorna diretamente
  if (typeof valor === 'number') {
    return valor;
  }
  // Se for string formatada, converte para número
  return parseFloat(valor.replace(/^R\$\s?/, '').replace(/\./g, '').replace(',', '.')) || 0;
}